module.exports = __webpack_public_path__ + "static/hero-image-3@3x-0b8577b8de20fcc2577f55b5d35eb02c.jpg";